import axios, { type AxiosInstance } from 'axios'
import { useAuthStore } from '@/stores/auth'

const baseURL = import.meta.env.VITE_API_BASE_URL || ''

// In demo-modus gebruiken we de fetch-adapter zodat onze window.fetch override
// in demo-mocks.ts ook axios-calls onderschept.
const demoActief =
  typeof window !== 'undefined' && window.localStorage.getItem('voorraad-kh-demo') === '1'

export const api: AxiosInstance = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
  ...(demoActief ? { adapter: 'fetch' as const } : {}),
})

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err.response?.status === 401) {
      useAuthStore.getState().logout()
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(err)
  }
)
